import { inquiryShopListSet } from './modules/inquiryShopList'

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    // 全ページ共通適用
    const currentShopName = localStorage.getItem('shopName')
    const currentShopID = localStorage.getItem('shopID')
    const currentShopSlug = localStorage.getItem('shopSlug')
    const currentShopBikeID = localStorage.getItem('goBikeID')
    const currentShopLogoPath = localStorage.getItem('logoPath')
    const currentShopTel = localStorage.getItem('shopTel')

    if (currentShopID) {
      document.querySelector('[data-shop-logo]').setAttribute('src', currentShopLogoPath)

      Array.from(document.querySelectorAll('[data-shop-tel]')).forEach((el) => {
        el.setAttribute('href', `tel:${currentShopTel.replace(/-/g, '')}`)
        el.innerText = currentShopTel
      })
      Array.from(document.querySelectorAll('[data-rental-bike-link]')).forEach((el) => {
        el.setAttribute('href', `https://hondago-bikerental.jp/store/detail/${currentShopBikeID}`)
      })
      Array.from(document.querySelectorAll('[data-shop-top-link]')).forEach((el) => {
        el.setAttribute('href', `/shop/${currentShopSlug}`)
      })
      Array.from(document.querySelectorAll('[data-inquiry-link]')).forEach((el) => {
        el.setAttribute('href', `/inquiry/?shop_id=${currentShopID}`)
      })
      Array.from(document.querySelectorAll('[data-information-link]')).forEach((el) => {
        el.setAttribute('href', `/category/information/?shop_id=${currentShopID}`)
      })
      Array.from(document.querySelectorAll('[data-event-link]')).forEach((el) => {
        el.setAttribute('href', `/category/event/?shop_id=${currentShopID}`)
      })

      Array.from(document.querySelectorAll('[data-information-shop-filter]')).forEach((el) => {
        if (currentShopName) {
          el.innerText = `(${currentShopName})`
        }
      })
    } else {
      document.querySelector('[data-shop-tel-wrap]').remove()
    }

    inquiryShopListSet()

    Array.from(document.querySelectorAll('.global-footer__nav dt')).forEach((item) => {
      item.addEventListener('click', () => {
        item.classList.toggle('is-open')
      })
    })

    Array.from(document.querySelectorAll('[data-modal-trigger]')).forEach((item) => {
      item.addEventListener('click', () => {
        const target = `.${item.getAttribute('data-modal-target')}`
        this.body.classList.add('view-modal')
        document.querySelector(target).classList.add('is-open')
      })
    })

    Array.from(document.querySelectorAll('[data-close-target]')).forEach((item) => {
      item.addEventListener('click', () => {
        const target = `.${item.getAttribute('data-close-target')}`
        this.body.classList.remove('view-modal')
        document.querySelector(target).classList.remove('is-open')
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.ex = new App()
})

window.addEventListener('load', () => {})
